<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="OrderForecastExportTable" :fields="fields" :title="table_title.title1"
        :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :isBusy="isBusy_table" :query_button_label="query_lable" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 1]" @tool_invoke="tool_invoke" @current_changed="current_changed" tableref="37d5e881c8864be7a6c6086af51bf8bd">
        <template #toolbar="">
          <div style="display: inline-block">
            <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" accept=".xlsx"
              :on-exceed="exceed" :limit="1" :on-remove="remove" :http-request="uploadFile"
              :before-upload="beforeFileUpload" :show-file-list="false" :file-list="fileList" :on-success="successFile">
              <el-button plain type="info" style="width: 55px" class="ml-2"><i
                  class="iconfont icon-export-in"></i></el-button>
              <!-- <div slot="tip" class="el-upload__tip">1次只能上传1个xls文件</div> -->
            </el-upload>
          </div>
          <!-- <a href="" class="ml-2 mb-0">模板下载</a> -->
          <el-tooltip content="模板下载" placement="top" effect="light">
            <el-button plain type="info" style="width: 55px" @click="downloadTemplate" class="ml-2"><i
                class="iconfont icon-template"></i>
            </el-button>
          </el-tooltip>
        </template>
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveExport"
            :label="$t('common.save')" class="ml-2">
          </QueryButton>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import XLSX from "xlsx"
import * as CustTableController from "../../controllers/base/CustTableController"
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"
import * as OrderForecastExportController from "../../controllers/sd/OrderForecastExportController"
import * as base_url from "../../shared/base_url"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import TableMain from "../components/table/TableMain"
export default {
  name: "OrderForecastExport",
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      fileList: [],
      table_title: {
        title1: "table_forecast_import",
      },
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      fields: OrderForecastExportController.fields.default,
      dataList: [],
      isBusy_table: false,
      base_url: base_url.base_url,
    }
  },
  created() { },
  methods: {
    downloadTemplate() {
      window.location.href =
        this.base_url + "/excel_template/" + "预测订单导入模板20240802.xlsx"
    },
    current_changed(old, current) { },
    tool_invoke(data) { },
    state_change(data, cb) {
      if (data.state === "deleted") {
        this.$refs.OrderForecastExportTable.RemoveItems(data.selected_items)
      }
    },
    //上传1个以上文件时弹窗提示错误
    exceed: function () {
      // this.$message.error("最多只能上传1个xls文件");
      this.msgToasts("最多只能上传1个xls文件!", "info")
    },
    //删除
    remove() { },
    successFile() {
      //this.isBusy_table3 = false
    },
    async uploadFile(params) {
      let now_date = await commonController.methods.getServerDateTime()
      now_date = new Date(now_date.today)
      this.isBusy_table = true
      this.$refs.OrderForecastExportTable.SetData([])
      let _this = this
      let _file = params.file
      let fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          let data = ev.target.result
          let workbook = XLSX.read(data, {
            type: "binary",
            cellDates: true,
          })
          let listTable = []

          let _keys_sheets = _.keys(workbook.Sheets)
          let sheet = workbook.Sheets[_keys_sheets[0]]
          let sheetArray = XLSX.utils.sheet_to_json(sheet, { defval: "" })
          if (sheetArray.length == 0) {
            this.msgToasts("请选择有数据的模板！", "error")
            return
          }
          ///检查模板是否正确
          let _sheet_keys = _.keysIn(sheetArray[0])
          let _fields_keys = _.keysIn(_.keyBy(this.fields, "label"))
          let dif = _.difference(_fields_keys, _sheet_keys)
          if (dif.length > 0) {
            this.msgToasts("模板不正确！", "error")
            return
          }

          // console.log(sheetArray)
          _.each(sheetArray, (t) => {
            let _p = {}
            _.forIn(_.keyBy(this.fields, "label"), (v, k) => {
              if (_.isDate(t[k])) {
                _p[v.key] = _this.$date.format(
                  _this.$date.addDays(t[k], 1),
                  "yyyy-MM-dd"
                )
              } else {
                _p[v.key] = t[k]
              }
              if (v.key == "StartDate") {
                if (_p[v.key] == "" || _.isNull(_p[v.key])) {
                  _p[v.key] = _this.$date.format(now_date, "yyyy-MM-dd")
                }
              }
            })
            listTable.push(_p)
          })
          console.log(listTable)
          _this.$refs.OrderForecastExportTable.SetData(listTable)
        } catch (e) {
          // console.log(e);
          // this.$message.warning("文件类型不正确！");
          this.msgToasts("文件类型不正确！!", "info")

          this.isBusy_table = false
        }
      }
      fileReader.readAsBinaryString(_file)
      this.isBusy_table = false
      this.fileList = []
    },
    //before上传
    beforeFileUpload() { },
    //保存
    async saveExport(cb) {
      if (this.$refs.OrderForecastExportTable.my_data.length == 0) {
        cb(false)
        return
      }
      let _bool = true

      //检查数量
      _.each(this.$refs.OrderForecastExportTable.my_data, (t) => {
        if (t.SalesQty <= 0) {
          _bool = false
        }
      })
      if (!_bool) {
        this.msgToasts("数量必须大于零!", "error")
        cb(false)
        return
      }

      //let _is_ok = true;
      let _data = _.cloneDeep(this.$refs.OrderForecastExportTable.my_data)
      let data = { username: this.$global.global_data.local_username }
      data.data = _data
      let result =
        await OrderForecastExportController.methods.SaveSalesForcastExport(
          JSON.stringify(data)
        )
      if (result && result.length > 0) {
        //判断后台是否写入成功
        if (result[0][0].status == 0) {
          this.$refs.OrderForecastExportTable.SetData([])
          this.msgToasts(this.$t("notify.import_success"), "success")
          this.$refs.OrderForecastExportTable.SetData([])
          cb(true, true)
        } else {
          let str = "<div><strong>" + this.$t("notify.import_failed_error") + "</strong></div>"
          _.each(result[0], (t) => {
            if (
              _.isNull(t.ModelName) ||
              _.isNull(t.NameAlias) ||
              _.isNull(t.customerName) ||
              _.isNull(t.dataAreaId) ||
              _.isNull(t.companyName)
            ) {
              console.log(t)
              //标红错误行
              let item =
                this.$refs.OrderForecastExportTable.my_data[parseInt(t._id)]
              item._rowVariant = "danger"
              item._selected = true
              this.$set(
                this.$refs.OrderForecastExportTable.my_data,
                t._id,
                item
              )
              str += this.ErrorMsg(t)
            }
          })
          this.msgToasts(str, "error", 0, true, "notify550")
          cb(false)
          return
        }
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(false)
        return
      }

    },
    ErrorMsg(data) {
      if (_.isNull(data.NameAlias)) {
        return ("<div>" + this.$t("common.customer") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.invent") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.customerName)) {
        return ("<div>" + this.$t("common.customer") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.customer") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.companyName)) {
        return ("<div>" + this.$t("common.customer") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.company") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.ModelName)) {
        return ("<div>" + this.$t("common.customer") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.forecast_modal") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      return ""
    },
    //获取客户信息
    async getCustInfo(_data) {
      let _acc_list = _.keys(_.keyBy(_data, "AccountNum"))
      let _p = {
        AccountNum: { in: _acc_list },
      }
      let _result = await CustTableController.methods.getItemData(_p)
      let _check_acc_list = []
      if (!_.isNull(_result) && _result && _result[0].length > 0) {
        _.each(_acc_list, (t) => {
          let _index = _.findIndex(_result[0], { AccountNum: t })
          if (_index < 0) {
            _check_acc_list.push(t)
          }
        })
        if (_check_acc_list.length == 0) {
          _.each(_data, (t) => {
            let _m = _.find(_result[0], {
              AccountNum: t.AccountNum,
              dataAreaId: t.dataAreaId,
            })

            if (_m) {
              t.ForecastSalesId = ""
              t.CustAccountId = t.AccountNum
              t.TEC_FinalCustAccount = t.AccountNum
              t.CustAccountName = _m.SEI_Name
              t.MainContactWorker = _m.MainContactWorker
              t.SEI_SalesGroup = _m.SEI_SalesGroup
              t.SegmentId = _m.SegmentId
              t.CurrencyCode = _m.Currency
              t.InclTax = _m.InclTax
              t.TEC_FinalCustAccount_Name = _m.SEI_Name

              delete t.AccountNum
            }
          })

          return true
        } else {
          this.msgToasts(
            "客户编码：" +
            _.join(_check_acc_list, "，") +
            "不存在，请核实后再导入！",
            "error"
          )
          return false
        }
      } else {
        this.msgToasts("客户编码错误，请核实后再导入！", "error")
        return false
      }
    },
    //获取物料信息
    async getNameAlias(_data) {
      let _invent_list = _.keys(_.keyBy(_data, "ItemId"))
      let _p = {
        ItemId: { in: _invent_list },
      }
      let _result = await InventTableController.methods.getDataNoSql(_p)
      console.log(_result[0])
      let _check_invent_list = []
      if (!_.isNull(_result) && _result && _result[0].length > 0) {
        _.each(_invent_list, (t) => {
          let _index = _.findIndex(_result[0], { ItemId: t })
          if (_index < 0) {
            _check_invent_list.push(t)
          }
        })
        if (_check_invent_list.length == 0) {
          _.each(_data, (t) => {
            let _m = _.find(_result[0], { ItemId: t.ItemId })

            if (_m) {
              t.ForecastSalesId = ""
              t.NameAlias = _m.NameAlias
              t.SalesUnitId = _m.SalesUnitId
              t.is_invent_ready = false
              t.valid_remain = t.SalesQty
              t.valid_approve = 0
            }
          })

          return true
        } else {
          this.msgToasts(
            "SEI物料编号：" +
            _.join(_check_acc_list, "，") +
            "不存在，请核实后再导入！",
            "error"
          )
          return false
        }
      } else {
        this.msgToasts("SEI物料编号错误，请核实后再导入！", "error")
        return false
      }
    },
  },
}
</script>
